import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import TopicNote, { TopicNoteType } from '@/components/TopicNote';
import { JobNotesCardProps } from './JobNotesCard.container';
import * as Styles from './JobNotesCard.styles';
import Menu from '../Menu';

export type JobNotesCardComponentProps = TopicNoteType &
  Omit<JobNotesCardProps, 'onAddNewNote' | 'onChangeCandidateField'> & {
    newTopicNote: string;
    userName: string;
    onSelectTopicToDelete: (id: string) => void;
    onOpenEditModal: () => void;
  };

const JobNotesCardComponent = function ({
  title,
  userName,
  id,
  onChangeHandler,
  onSaveNote,
  notes,
  newTopicNote,
  onEditNote,
  onUpdateNote,
  onDeleteNote,
  onCancelEditingNote,
  isSubmiting,
  onSelectTopicToDelete,
  onOpenEditModal,
}: JobNotesCardComponentProps): JSX.Element {
  return (
    <Styles.TopicCard id={id}>
      <Styles.CardHeader>
        <Styles.TopicTitle>{title}</Styles.TopicTitle>
        <Menu
          icon={MoreHorizIcon}
          menuId={`${id}-id`}
          menuItems={[
            {
              label: 'Edit',
              menuItemIcon: CreateIcon,
              callback: onOpenEditModal,
            },
            {
              label: 'Delete',
              menuItemOptions: { warning: true },
              menuItemIcon: DeleteIcon,
              callback: (event) => {
                event.stopPropagation();
                onSelectTopicToDelete(id);
              },
            },
          ]}
        />
      </Styles.CardHeader>

      <div>
        {notes.map((note, index) => {
          return (
            <TopicNote
              isSubmiting={isSubmiting}
              key={note.id}
              onCancelEditingNote={() => onCancelEditingNote(index)}
              onDeleteNote={() => onDeleteNote(index)}
              onSaveNote={() => onSaveNote(index)}
              onChangeHandler={onChangeHandler}
              onUpdateNote={(event) => onUpdateNote && onUpdateNote(event, index)}
              onEditNote={() => onEditNote && onEditNote(index)}
              {...note}
            />
          );
        })}

        <TopicNote
          isNewInput
          isSubmiting={isSubmiting}
          author={{ name: userName }}
          onSaveNote={onSaveNote}
          onCancelEditingNote={onCancelEditingNote}
          onDeleteNote={() => {}}
          onEditNote={() => {}}
          onUpdateNote={(event) => onUpdateNote && onUpdateNote(event)}
          onChangeHandler={onChangeHandler}
          text={newTopicNote}
        />
      </div>
    </Styles.TopicCard>
  );
};

export default JobNotesCardComponent;
